import {
  Button,
  Card,
  Checkbox,
  Form,
  Grid,
  Icon,
  Tab,
} from 'semantic-ui-react';
import React, { Component } from 'react';

import Details from './video_gallery/details';
import { convertGraphQlToObject } from '../../../../helpers/contentWithI18n';
import { createTranslationsObject } from '../../../../helpers/translation';
import { languages } from '../../../../constants';

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange };
    return {
      menuItem: language.label,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  return panes;
};

class VideoGalleryBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      obj: {
        id: null,
        type: 'video_gallery_block',
        cta_target_blank: false,
        translations: createTranslationsObject({
          title: '',
          content: '',
          cta_label: '',
          cta_url: '',
        }),
      },
      slides: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSlideChange = this.handleSlideChange.bind(this);
  }

  componentWillMount() {
    if (this.props.obj) {
      const objWithoutSlides = { ...this.props.obj };
      delete objWithoutSlides.slides;
      const obj = convertGraphQlToObject(objWithoutSlides);
      const newObj = { ...this.state.obj };

      newObj.id = obj.id;
      newObj.cta_target_blank = obj.cta_target_blank || false;
      newObj.translations = obj.translations;

      this.setState({
        obj: newObj,
        slides: this.props.obj.slides,
      });
    }
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({
      slides: [
        ...this.state.slides,
        { video_url_fr: '', video_url_en: '', title_fr: '', title_en: '' },
      ],
    });
  };

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    let dataIsLanguage = false;
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true;
      }
    }

    if (dataIsLanguage) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value;
    } else if (type === 'dropdown' || type === 'image') {
      //dropdown or image
      newState.obj[data.id] = data.value;
    } else if (type === 'checkbox') {
      newState.obj[data.id] = data.checked;
    } else if (data.radio === true) {
      newState.obj[data.name] = data.value;
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value;
    }

    this.setState(newState);
  }

  handleSlideChange = (e, id, key) => {
    let gallery = [...this.state.slides].map((slide, i) => {
      if (i === id) {
        const s = { ...slide };
        s[key] = e.target.value;
        return s;
      }

      return slide;
    });

    this.setState({
      slides: gallery,
    });
  };

  handleDelete = (e, i) => {
    let gallery = [...this.state.slides];
    gallery.splice(i, 1);
    this.setState({
      slides: gallery,
    });
  };

  handleMoveSlide = (sort, index) => {
    const gallery = [...this.state.slides];
    if (sort === 'up') {
      if (index !== 0) {
        const tmp = gallery[index - 1];
        gallery[index - 1] = gallery[index];
        gallery[index] = tmp;
      }
    } else {
      if (index !== this.state.slides.length) {
        const tmp = gallery[index + 1];
        gallery[index + 1] = gallery[index];
        gallery[index] = tmp;
      }
    }

    this.setState({
      slides: gallery,
    });
  };

  getValues = () => {
    return {
      ...this.state.obj,
      slides: this.state.slides,
    };
  };

  renderSlide = (item, i) => {
    return (
      <Grid key={i} columns={3}>
        <Grid.Row>
          <Grid.Column width={1}>
            {i !== 0 && (
              <div>
                <Button
                  icon
                  onClick={(e) => {
                    this.handleMoveSlide('up', i);
                  }}
                >
                  <Icon name="arrow up" />
                </Button>
                <br />
                <br />
              </div>
            )}
            {this.state.slides.length - 1 !== i && (
              <Button
                icon
                onClick={(e) => {
                  this.handleMoveSlide('down', i);
                }}
              >
                <Icon name="arrow down" />
              </Button>
            )}
          </Grid.Column>
          <Grid.Column width={14}>
            <Form.Field>
              <Form.Input
                placeholder="Url vidéo Youtube Français"
                id="video_url_fr"
                fluid
                label="Url vidéo Youtube Français"
                value={item.video_url_fr}
                onChange={(e) => this.handleSlideChange(e, i, 'video_url_fr')}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                placeholder="Url vidéo Youtube Anglais"
                id="video_url_en"
                fluid
                label="Url vidéo Youtube Anglais"
                value={item.video_url_en}
                onChange={(e) => this.handleSlideChange(e, i, 'video_url_en')}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                placeholder="Titre Français"
                id="title_fr"
                fluid
                label="Titre Français"
                value={item.title_fr}
                onChange={(e) => this.handleSlideChange(e, i, 'title_fr')}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                placeholder="Titre Anglais"
                id="title_en"
                fluid
                label="Titre Anglais"
                value={item.title_en}
                onChange={(e) => this.handleSlideChange(e, i, 'title_en')}
              />
            </Form.Field>
          </Grid.Column>
          <Grid.Column width={1}>
            <Button
              icon
              color="red"
              onClick={(e) => {
                this.handleDelete(e, i);
              }}
            >
              <Icon name="delete" />
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  renderSlides = () => {
    return this.state.slides.map((slide, i) => {
      return this.renderSlide(slide, i);
    });
  };

  render() {
    const { onDelete } = this.props;
    const { obj } = this.state;

    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>
            Bloc Galerie Vidéos
            {onDelete && (
              <Button
                size="mini"
                floated="right"
                icon
                color="red"
                type="submit"
                onClick={onDelete}
              >
                <Icon name="delete" />
              </Button>
            )}
            {/* {index !== max - 1 && <Button size='mini' floated='right' icon onClick={(e) => { onMoveBlock('down', index) }}><Icon name="arrow down" /></Button>}
            {index !== 0 && <Button size='mini' floated='right' icon onClick={(e) => { onMoveBlock('up', index) }}><Icon name="arrow up" /></Button>} */}
            <Button size="mini" floated="right" onClick={this.handleClick}>
              <Icon name="sliders" /> Ajouter un slide
            </Button>
          </Card.Header>
        </Card.Content>
        <Card.Content>{this.renderSlides()}</Card.Content>

        <Card.Content>
          <Card.Description>
            <Tab
              menu={{ pointing: true }}
              panes={renderPanes(this.state.obj, this.handleChange)}
            />
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

export default VideoGalleryBlock;



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/blocks/video_gallery_block.js